import clsx from "clsx"
import { ListProductData } from "src/data/product-list/types"
import { AddToCartButton } from "../styled/AddToCartButton"
import { DiscountHeader } from "../styled/DiscountHeader"
import { PriceShort } from "../styled/PriceShort"
import { ProductPrimaryLink } from "../styled/ProductPrimaryLink"
import { ShippingInfo } from "../styled/ShippingInfo"
import { ProductLink } from "../unstyled/ProductLink"
import { ProductListItemImage } from "./ProductListItemImage"
import { ProductListItemName } from "./ProductListItemName"

export type ProductListAction = "goToProduct" | "addToCart"

export type ProductListItemProps = {
  listId: string
  product: ListProductData
  action?: ProductListAction
}

export const ProductListItem = ({ listId, product, action = "goToProduct" }: ProductListItemProps) => {
  const { id: resolvedId, slogan, image, price, regularPrice, discount, coupon, available } = product

  return (
    <div
      className={clsx("flex w-full max-w-94 flex-col rounded-3xl text-center", {
        "bg-elvent-discount leading-none": discount && available,
      })}
    >
      <DiscountHeader discount={discount} coupon={coupon} regularPrice={regularPrice} available={available} />

      <div
        className={clsx("flex flex-1 flex-col items-center gap-4 rounded-3xl border bg-white px-4 py-8 xl:gap-6", {
          "border-elvent-discount": discount && available,
        })}
      >
        {image && (
          <ProductLink product={product} listId={listId} className="aspect-square w-full">
            <ProductListItemImage src={image} alt={product.name} />
          </ProductLink>
        )}

        <div className="flex-1">
          <ProductLink product={product} listId={listId}>
            <ProductListItemName name={product.name} />
          </ProductLink>

          {product.slogan && <div className="text-lg">{slogan}</div>}
        </div>

        <div className="mx-auto">
          <PriceShort price={price} regularPrice={regularPrice} textAlign="center" size="md" />
        </div>

        <div className="flex w-full flex-col px-4">
          {action === "addToCart" ? (
            <AddToCartButton resolvedId={resolvedId} price={price} available={available} text="Mitbestellen" />
          ) : (
            <ProductPrimaryLink product={product} listId={listId} />
          )}
        </div>

        <ShippingInfo fulfillmentFrom={product.fulfillmentFrom} freeShipping={product.freeShipping} />
      </div>
    </div>
  )
}
